import React from "react";
import "./Home.css";
import slide4 from "../../assets/images/003.jpg";
// import slide3 from "../../assets/slides/img3.webp";
import slide2 from "../../assets/images/002.jpg";
import slide1 from "../../assets/images/001.jpg";
import pdfFile from '../../assets/docs/IITCEEE 2026_Dec 16.pdf';
import { Carousel } from "react-responsive-carousel";
import imgA from "../../assets/images/imgA.png";
import imgB from "../../assets/images/imgB.png";
import imgC from "../../assets/images/imgC.png";
import pdf from "../../assets/docs/Hotels Near by BNMIT.pdf"

const Home = () => {
  return (
    <div className="Home">
      <div>
        <Carousel
          autoPlay={true}
          infiniteLoop={true}
          swipeable={true}
          showThumbs={false}
          interval={2000}
        >
          <div>
            <img src={slide1} />
          </div>
          <div>
            <img src={slide2} />
          </div>
          {/* <div>
            <img src={slide3} />
          </div> */}
          <div>
            <img src={slide4} />
          </div>
        </Carousel>
      </div>
     <div className="home-content">


  <span style={{ fontSize: "4rem", textAlign: "center" }}>
    WELCOME TO <span className="home-title">IITCEE 2026! </span>
  </span>
        
        
       {/* <div style={{ marginTop: "2rem", textAlign: "center" }}>
  <a
    href="https://www.youtube.com/live/ZKjUQI2rm0c"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      fontSize: "2rem",
      fontWeight: "700",
      color: "blue",
      textDecoration: "underline",
      textShadow: "0 0 8px rgba(0,128,128,0.7)"
    }}
  >
    Click here to watch the live broadcast of the IEEE International Conference - IITCEE 2026
  </a>
</div>*/}


<div className="part">
    <span>
      IEEE Conference Record :{" "}
      <span style={{ color: 'teal' }}>67948</span>
    </span>
    <span>
      IEEE ISBN :{" "}
      <span style={{ color: 'teal' }}>979-8-3315-7746-9</span>{" "}
    </span>
    <span>
      IEEE Part No. :{" "}
      <span style={{ color: 'teal' }}>CFP26DA7-ART</span>{" "}
    </span>
  </div>
        <div className="download-container">
  <div className="dropdown">
    <span className="dropdown-title">Previous Conference</span>
    <div className="dropdown-content">
      <a href="https://iitcee2026.bnmit.in/" target="_blank" rel="noopener noreferrer">2026</a>
      <a href="https://ieeexplore.ieee.org/search/searchresult.jsp?newsearch=true&queryText=iitcee%202025" target="_blank" rel="noopener noreferrer">2025</a>
      <a href="https://ieeexplore.ieee.org/search/searchresult.jsp?newsearch=true&queryText=iitcee%202024
" target="_blank" rel="noopener noreferrer">2024</a>
      <a href="https://ieeexplore.ieee.org/search/searchresult.jsp?newsearch=true&queryText=iitcee%202023
" target="_blank" rel="noopener noreferrer">2023</a>
    </div>
  </div>
</div>
    <a
  href={pdfFile}
  target="_blank"
  rel="noopener noreferrer"
  className="brochure-link"
>
  Broucher
</a>
 <div className="download-buttons">
    <a
      href="https://drive.google.com/file/d/10dI6CCdFx_On38zMPXPJsfi2XyRdVhSM/view?usp=sharing"
      target="_blank"
      rel="noopener noreferrer"
      className="btn download-btn"
    >
      Paper Presentation Schedule
    </a>

    <a
      href="https://docs.google.com/presentation/d/1DktkGZeVmkN4jWctTpz84_HjBRzpHg7q/edit?usp=sharing&ouid=116725702212176299626&rtpof=true&sd=true"
      target="_blank"
      rel="noopener noreferrer"
      className="btn download-btn"
    >
      PPT Template
    </a>

    <a
      href={pdf}
      target="_blank"
      rel="noopener noreferrer"
      className="btn download-btn"
    >
      Accommodation Details
    </a>
  </div>



        <div className="about-conference">
          <div className="arrange">
            <div className="text">
              <h2 className="international-Conference">
                4<sup>th</sup> International Conference on Intelligent and Innovative Technologies in Computing, Electrical and Electronics - ICIITCEE 2026, Jan 22-23
                <h2>Technically Co-Sponsored by IEEE Bangalore Section</h2>
              </h2>
            </div>
       
          </div>
          <p>
            International Conference on Intelligent and Innovative Technologies in
                        Computing, Electrical and
                        Electronics (ICIITCEE 2026) is organized and hosted by BNM Institute of Technology, Bengaluru, India
                        on 22 and 23 January 2026. This conference will feature a comprehensive technical program including
                        several special sessions and workshops. The goal of ICIITCEE 2026 is to provide an outstanding forum
                        for academicians, researchers, practitioners, policymakers and students to exchange ideas,
                        techniques and tools, raise awareness, and share experiences related to all practical and
                        theoretical aspects of intelligence and innovations in engineering. 
           
          </p>

          <p style={{ textAlign: "justify" }}>
            ICIITCEE 2026 focuses on issues and solutions involving Intelligent
            and Innovative Technologies in Computing, Electrical and
            Electronics. Developments in the field of Computing, Electrical and
            Electronics are very complex and advance rapidly as changes occur on
            day to day basis. It is very difficult to make it available to all
            stakeholders (researchers, academicians, students, industrialists
            and society). Hence, the objectives of the conference are:
          </p>
          <ul>
            <li>
              &mdash;&nbsp;&nbsp;To provide a platform to stakeholders to meet
              and share the ideas, views and new findings in the field of
              contemporary Computing, Electrical and Electronics.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To provide a platform for stakeholders to meet
              and share ideas, views and new findings in the field of
              contemporary Computing, Electrical and Electronics.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To strengthen the relationship with industries
              and academic institutions of Karnataka and Bengaluru and, with the
              rest of the world.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To provide a space for students and researchers
              to meet, discuss, and learn with experts in the related field.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To bridge the gap between the industry and
              academics.
            </li>
            <li>
              &mdash;&nbsp;&nbsp;To promote a high level of interaction among
              stakeholders in theoretical, experimental, and applied concepts in
              the field of Computing, Electrical and Electronics.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Home;